// src/components/admin/StatCardSkeleton.tsx

export function StatCardSkeleton() {
    return (
        <div className="bg-white p-6 rounded-lg shadow-subtle flex items-center gap-6 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-100/50 to-transparent animate-shimmer"></div>
            <div className="w-16 h-16 bg-gray-200 rounded-full"></div>
            <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
                <div className="h-8 bg-gray-200 rounded w-3/4"></div>
            </div>
        </div>
    );
}